import angular from 'angular';
import _ from 'lodash';
import template from './template.html';
import '../linkedin/style.scss';
import '../linkedin/summary';
import {
    LINEKDIN_SELECT_MESSAGE_TEMPLATE_STATE,
    LINEKDIN_SUMMARY_TEMPLATE_STATE,
} from './step-contants';
import { STATUS_FAIL, STATUS_SENT, STATUS_SKIP } from './select-linkedin-inmail-template';
import MessageFormatter from '../../service/message-formatter';
import { MESSAGE_TYPE_LINKEDIN_INMAIL } from '../../index';
import { CONTACT_CHANNEL_TYPES } from '../../../recruiter/constants/contactTypes';

export class LinkedinInmailMode {
    currentStep = LINEKDIN_SELECT_MESSAGE_TEMPLATE_STATE;

    summary = {
        skipped: 0,
        sent: 0,
        failed: 0,
    };

    /* @ngInject */
    constructor($timeout, RouteService, ContactCandidateService) {
        this.$timeout = $timeout;
        this.RouteService = RouteService;
        this.contactCandidateService = ContactCandidateService;
    }

    async $onInit() {
        this.loading = true;
        const templates = await this.getMessageTemplates();

        this.$timeout(() => this.templates = templates);
        this.loading = false;
    }

    async getMessageTemplates() {
        const language = this.RouteService.getUserPreference('uiLanguage') || 'en-US';

        return this.contactCandidateService.getMessageTemplatesByContactChannel({
            channel: CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE,
            language,
            positionId: this.position._id,
        });
    }

    async sendMessage({ email, candidate, selectedMessage }) {
        const { position } = this;

        const { result: positionApprovalLinkData } = await this.RouteService.getPositionApprovalLinks(position._id, {
            candidates: [{
                emails: _.get(candidate, 'candidateData.contact.emailAddress') || [],
                talentId: _.get(candidate, 'workflow.talentId'),
                workflowId: _.get(candidate, 'workflow._id'),
                channelType: 'inmail',
            }],
            sentBy: 'recruiter',
        });

        const positionApprovalLink = _.get(positionApprovalLinkData, '0.link', null);
        const messageUuid = _.get(positionApprovalLinkData, '0.messageUuid');
        _.set(selectedMessage, 'messageUuid', messageUuid);

        const emailWithSubstitutions = MessageFormatter.fillTemplate(
            { template: email.message, subject: email.subject },
            { ...candidate, positionApprovalLink },
            undefined,
            undefined,
            MESSAGE_TYPE_LINKEDIN_INMAIL,
        );

        const emailAddresses = _.get(candidate, 'candidateData.contact.emailAddress') || [];

        this.updateSummary(STATUS_SENT);

        return this.onSendLinkedinInmail({ candidate, email: emailWithSubstitutions, emailAddresses, selectedMessage });
    }

    skipMessage() {
        this.updateSummary(STATUS_SKIP);
    }

    onSentDone() {
        this.setStep(LINEKDIN_SUMMARY_TEMPLATE_STATE);
    }

    updateSummary(status) {
        if (status === STATUS_SENT) {
            this.summary.sent++;
        }

        if (status === STATUS_FAIL) {
            this.summary.failed++;
        }

        if (status === STATUS_SKIP) {
            this.summary.skipped++;
        }
    }

    setStep(step) {
        this.currentStep = step;
    }
}

export const linkedinInmailModeConfiguration = {
    template,
    controller: LinkedinInmailMode,
    bindings: {
        candidates: '<',
        recruiter: '<',
        position: '<',
        recruiterId: '<',
        onClose: '&',
        onDone: '&',
        onSendLinkedinInmail: '&',
    },
    controllerAs: 'ctrl',
};

angular.module('TALENYA-FE')
    .component('linkedinInmailMode', linkedinInmailModeConfiguration);
